import { Component, OnInit } from '@angular/core';
import { LayoutComponent } from '@Components';
import { AnalyticsService } from '@Services';

@Component({
  selector: 'app-root',
  imports: [LayoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'chis-hcp-portal';
  isIframe = false;

  // DO NOT REMOVE: injecting AnalyticsService is what instantiates it (it is
  // providedIn: 'root' and injected nowhere else). Its constructor wires the
  // router NavigationEnd -> gtag('page_view') tracking. Removing this stops all
  // Google Analytics pageviews (regression from PR 2651, fixed under T8017).
  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
  }
}
